import { STORAGE_KEYS } from '@/const/key-stores';
import { RedirectKey, RedirectURLs } from '@/const/redirects';
import { useAmplifyAuth } from '@/hooks/useAmplifyAuthRegisterRedirect';
import { useLocalStorage } from '@/hooks/useStorageManage';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

interface QueryObj {
  redirect?: string | undefined;
  state: { [key: string]: string };
}

/**
 * クエリパラメータに応じてリダイレクトする。
 * 例1 マイページへリダイレクトする場合）https://XXXXX/auth/redirect?redirect=mypage
 * 例2 予約日時選択へリダイレクトする場合）https://XXXXX/auth/redirect?redirect=reservation&outpatientid=XXX
 * @returns
 */
export const QueryStringRouteManage = () => {
  const { isAuthenticated } = useAmplifyAuth();
  const navigate = useNavigate();
  const { getStorageItem, removeStorageItem } = useLocalStorage();
  const [routeTrigger, setRouteTrigger] = useState<boolean>(false);

  async function handleNavigation() {
    const isAuth = await isAuthenticated();
    if (!isAuth) {
      return;
    }

    const redirectQsParam = getStorageItem(STORAGE_KEYS.QUERY_STRING);
    const searchQuery = new URLSearchParams(redirectQsParam ?? '');

    const query: QueryObj = { state: {} };
    searchQuery.forEach((value, key) => {
      if (key === 'redirect') {
        query['redirect'] = value;
      } else {
        query['state'][key] = value;
      }
    });

    setRouteTrigger(true);
    if (!query.redirect) {
      navigate(RedirectURLs.index.url, { replace: true });
      return;
    }

    if (!(query.redirect in RedirectURLs)) {
      navigate(RedirectURLs.index.url, { replace: true });
      return;
    }

    const key = query.redirect as RedirectKey;
    const target = RedirectURLs[key];
    const params = filterProperty(query.state, target.allowedQuery);
    Object.keys(params).length
      ? navigate(target.url, { state: { ...params, ...target.state }, replace: true })
      : navigate(target.url, { replace: true });
  }
  useEffect(() => {
    handleNavigation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!routeTrigger) return;
    removeStorageItem(STORAGE_KEYS.QUERY_STRING);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeTrigger]);

  return null;
};

const filterProperty = (obj: { [key: string]: string }, allowedKey: string[]) => {
  Object.keys(obj).forEach((key) => {
    if (!allowedKey.includes(key)) {
      delete obj[key];
    }
  });

  return obj;
};
